module.exports = __webpack_public_path__ + "media/assets/images/category/Christmas@2x-1f5dfc9ce71f306aea7b93a52bd8dca0.png";